import { Root } from 'protobufjs';
export function socketEncode(type, payload) {
    return new Promise(function (resolve, reject) {
        var root = Root.fromJSON(require('assets/protocol/to-server.json'));
        var message = root.lookupType(type);
        var error = message.verify(payload);
        if (error) {
            reject(error);
        }
        var buffer = message.encode(payload).finish();
        resolve(buffer);
    });
}
export function socketDecode(type, buffer) {
    return new Promise(function (resolve, reject) {
        try {
            var root = Root.fromJSON(require('assets/protocol/from-server.json'));
            var message = root.lookupType(type);
            var decoded = message.decode(buffer);
            // Convert to a plain object to avoid protobuf class instances with
            // circular prototype chains causing RangeError in RTK middleware.
            // We use toObject() (not toJSON()) so we can preserve the oneof
            // discriminator field (payload.kind) which toJSON() drops.
            var plain = message.toObject(decoded, {
                longs: Number,
                enums: String,
                bytes: String,
                defaults: false,
                arrays: true,
                objects: true,
                oneofs: true, // <-- preserves the `kind` discriminator field
            });
            resolve(plain);
        }
        catch (err) {
            reject(err);
        }
    });
}
